import { Injectable } from "@angular/core"
import { firstValueFrom } from "rxjs"
import { FireStoreService } from "@shared/service/fire-store.service"
import { REFERENTIAL, ReferentialDTO, ReferentialService } from "@app/pages/referential/referential.service"

@Injectable({
  providedIn: "root",
})
export class UnitV1Service extends FireStoreService<UnitV1DTO> {
  private unitsV2ReportCloudFunction = this.functions.httpsCallable("getUnitsV2Report")

  constructor(private refService: ReferentialService) {
    super()
    this.init({
      collectionKey: "units",
      fullTextFields: ["name"],
      sorting: {
        field: "name",
      },
    })
  }

  // rapport HTML de migration des pièces v1 => v2, recalculé à chaque appel
  getUnitsV2Report(): Promise<string> {
    return firstValueFrom(this.unitsV2ReportCloudFunction({})).then((res: { html: string }) => res.html)
  }

  toDTO(dto: any): Promise<UnitV1DTO> {
    // TO BE IMPROVED
    return Promise.all([this.refService.getAllFromCache(REFERENTIAL.unity_type)]).then((refs) => {
      const [refUnit] = refs
      const ref = refUnit.find((x: ReferentialDTO) => x.id === dto.type?.id)
      dto.type_label = ref?.name || "?"
      dto.type_color = ref?.color || "?"
      dto.migrated_label = dto.unitV2Id ? "OUI" : "NON"
      dto.migrated_label_color = dto.unitV2Id ? "blue" : ""
      return dto
    })
  }

  private _setIdToVersionsAndRoles(cmd: any): any {
    cmd.versions = cmd.versions?.map((version: UnitV1VersionDTO) => {
      version.id = version.id || this.uuid()
      version?.roles?.map((role: UnitV1RoleDTO) => {
        role.id = role.id || this.uuid()
        return role
      })
      return version
    })
    return cmd
  }

  beforeSavingHook(dto: any): any {
    return this._setIdToVersionsAndRoles(dto)
  }
}

export interface UnitV1DTO {
  id: string
  name: string
  subtitle?: string
  choreographer?: { id: string /*personId*/ }
  type: { id: string /*REFERENTIAL.unity_type*/ }
  versions: Array<UnitV1VersionDTO>
  unitV2Id?: string // posé par la migration v2 (tools/migrate-units-v2.js, ou popup de migration)

  type_label?: string
  type_color?: string
  migrated_label?: string
  migrated_label_color?: string
  // units: UnitV1DTO
}

export interface UnitV1VersionDTO {
  id: string
  duration: string
  name: string
  roles: Array<UnitV1RoleDTO>
}

export interface UnitV1RoleDTO {
  id: string
  name: string
  points: number
  group?: boolean
}
